import { Box } from '@deckee/deck-hand';
import styled from 'styled-components';

export const LayoutBody = styled(Box)`
  padding: ${({ theme }) => theme.space[2]}px;
`;
